/**
 * Мелкие виджеты auth-форм:
 *  - Person title carousel (Mr./Mrs./Ms.) — Alpine-компонент вместо Vue
 *  - Password toggle (показать/скрыть)
 *  - Search toggle в хедере
 *  - Pinup toggle
 */

import Alpine from 'alpinejs';
import { PERSON_TITLES } from './store.js';

/**
 * Регистрирует Alpine-компонент personTitle на замену Vue-виджета.
 *
 * Использование в Blade:
 *   <div x-data="personTitle" id="vue_person_title_01">
 *     <button @click="prev">-</button>
 *     <span x-text="showTitle"></span>
 *     <button @click="next">+</button>
 *     <input type="hidden" name="title" :value="showTitle">
 *   </div>
 */
Alpine.data('personTitle', () => ({
    index: 0,
    titles: PERSON_TITLES,
    get showTitle() { return this.titles[this.index]; },
    prev() {
        this.index = this.index === 0 ? this.titles.length - 1 : this.index - 1;
    },
    next() {
        this.index = this.index === this.titles.length - 1 ? 0 : this.index + 1;
    },
}));

export function initAuthWidgets() {
    document.addEventListener('click', e => {
        // Pinup toggle
        const pinupToggle = e.target.closest('[data-pinup-toggle]');
        if (pinupToggle) {
            const container = pinupToggle.closest('[data-pinup-container]');
            if (container) container.classList.toggle('active');
            return;
        }

        // Password show/hide
        const pwdToggle = e.target.closest('[data-password-toggler]');
        if (pwdToggle) {
            // Структура в Blade: <i class="..."></i><button data-password-toggler></button><input type="password">
            const input = pwdToggle.nextElementSibling;
            const icon = pwdToggle.previousElementSibling;
            if (input && input.tagName === 'INPUT') {
                if (icon) icon.classList.toggle('show');
                input.type = input.type === 'password' ? 'text' : 'password';
            }
            return;
        }

        // Search toggle в хедере
        const searchToggle = e.target.closest('[data-search-toggler]');
        if (searchToggle) {
            const searchBox = e.target.closest('.header_search');
            if (!searchBox) return;
            const opened = searchBox.classList.toggle('is_active');
            const input = searchBox.querySelector('.header_search_input');
            if (input) opened ? input.focus() : input.blur();
            // Раскладку лого пересчитывает скрипт в includes/header/header.blade.php
            document.dispatchEvent(new CustomEvent('header:search-toggle'));
        }
    });
}
